"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AchievementsCell = void 0;
var BoardManager_1 = require("../BoardManager");
var AchievementsBar_1 = require("../AchievementsBar");
var GameVars_1 = require("../../../GameVars");
var GameConstants_1 = require("../../../GameConstants");
var BoardScene_1 = require("../BoardScene");
var AudioManager_1 = require("../../../AudioManager");
var AchievementsCell = /** @class */ (function (_super) {
    __extends(AchievementsCell, _super);
    function AchievementsCell(scene, i) {
        var _this = _super.call(this, scene) || this;
        _this.i = i;
        _this.achievementInfo = GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? _this.scene.cache.json.get("achievements")["MODE_1"][i - 1] : _this.scene.cache.json.get("achievements")["MODE_2"][i - 1];
        var background = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "cell_achievement");
        _this.add(background);
        _this.achievementTitleLabel = new Phaser.GameObjects.Text(_this.scene, -25, -38, "", { fontFamily: "Baloo", fontSize: "22px", color: "#95573F" });
        _this.achievementTitleLabel.setOrigin(.5);
        _this.add(_this.achievementTitleLabel);
        _this.achievementDescriptionLabel = new Phaser.GameObjects.Text(_this.scene, -25, -5, "", { fontFamily: "Baloo", fontSize: "20px", color: "#FFFFFF", align: "center" });
        _this.achievementDescriptionLabel.setOrigin(.5);
        _this.achievementDescriptionLabel.setWordWrapWidth(200);
        _this.add(_this.achievementDescriptionLabel);
        _this.claimAchievementButton = new Phaser.GameObjects.Image(_this.scene, 156, 0, "texture_atlas_1", "btn_claim_off");
        _this.claimAchievementButton.setInteractive();
        _this.claimAchievementButton.on("pointerdown", function () {
            _this.onClickClaimAchievement();
        }, _this);
        _this.claimAchievementButton.on("pointerover", function () {
            _this.claimAchievementButton.setFrame("btn_claim_on");
            _this.achievementRewardLabel.setScale(1.1);
        }, _this);
        _this.claimAchievementButton.on("pointerout", function () {
            _this.claimAchievementButton.setFrame("btn_claim_off");
            _this.achievementRewardLabel.setScale(1);
        }, _this);
        _this.add(_this.claimAchievementButton);
        _this.achievementRewardLabel = new Phaser.GameObjects.Text(_this.scene, _this.claimAchievementButton.x + 20, 16, "", { fontFamily: "Baloo", fontSize: "24px", color: "#FFD445" });
        _this.achievementRewardLabel.setOrigin(1, .5);
        _this.achievementRewardLabel.setStroke("#703E25", 6);
        _this.add(_this.achievementRewardLabel);
        _this.claimAchievementButtonLocked = new Phaser.GameObjects.Image(_this.scene, 140, 0, "texture_atlas_1", "btn_achievements_reward_locked");
        _this.add(_this.claimAchievementButtonLocked);
        _this.achievementsBar = new AchievementsBar_1.AchievementsBar(_this.scene, _this.i);
        _this.achievementsBar.x = -25;
        _this.achievementsBar.y = 36;
        _this.add(_this.achievementsBar);
        _this.star1 = new Phaser.GameObjects.Image(_this.scene, -166 - 20, 36, "texture_atlas_1", "star_achievement_full");
        _this.add(_this.star1);
        _this.star2 = new Phaser.GameObjects.Image(_this.scene, -166, 36, "texture_atlas_1", "star_achievement_full");
        _this.add(_this.star2);
        _this.star3 = new Phaser.GameObjects.Image(_this.scene, -166 + 20, 36, "texture_atlas_1", "star_achievement_full");
        _this.add(_this.star3);
        _this.reset(i);
        return _this;
    }
    AchievementsCell.prototype.reset = function (number) {
        this.achievementTitleLabel.text = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["ACHIEVEMENTS"][this.i - 1]["title"];
        this.achievementDescriptionLabel.text = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["ACHIEVEMENTS"][this.i - 1]["description"];
        var achievementData = GameVars_1.GameVars.modeGameData.achievementsData[this.i - 1];
        var rewardValue = 0;
        this.rewardIndex = -1;
        var stars = 3;
        var treshold = this.achievementInfo.tresholds[2];
        if (achievementData.claims[0] === false) {
            rewardValue = this.achievementInfo.prizes[0];
            treshold = this.achievementInfo.tresholds[0];
            this.rewardIndex = 0;
            stars = 0;
        }
        else if (achievementData.claims[1] === false) {
            rewardValue = this.achievementInfo.prizes[1];
            treshold = this.achievementInfo.tresholds[1];
            this.rewardIndex = 1;
            stars = 1;
        }
        else if (achievementData.claims[2] === false) {
            rewardValue = this.achievementInfo.prizes[2];
            treshold = this.achievementInfo.tresholds[2];
            this.rewardIndex = 2;
            stars = 2;
        }
        this.achievementRewardLabel.text = GameVars_1.GameVars.formatNumber(rewardValue);
        this.achievementDescriptionLabel.text = this.achievementDescriptionLabel.text.replace("*", GameVars_1.GameVars.formatNumber(treshold));
        if (this.rewardIndex === -1) {
            this.claimAchievementButton.visible = false;
            this.achievementRewardLabel.visible = false;
            this.claimAchievementButtonLocked.visible = true;
        }
        else {
            if (achievementData.current >= treshold) {
                this.claimAchievementButton.input.enabled = true;
                this.claimAchievementButton.visible = true;
                this.achievementRewardLabel.visible = true;
                this.claimAchievementButtonLocked.visible = false;
                BoardScene_1.BoardScene.currentInstance.markAchievements();
            }
            else {
                this.claimAchievementButton.input.enabled = false;
                this.claimAchievementButton.visible = false;
                this.achievementRewardLabel.visible = false;
                this.claimAchievementButtonLocked.visible = true;
                this.claimAchievementButton.setFrame("btn_claim_off");
                this.achievementRewardLabel.setScale(1);
            }
        }
        switch (stars) {
            case 0:
                this.star1.setFrame("star_achievement_void");
                this.star2.setFrame("star_achievement_void");
                this.star3.setFrame("star_achievement_void");
                break;
            case 1:
                this.star1.setFrame("star_achievement_full");
                this.star2.setFrame("star_achievement_void");
                this.star3.setFrame("star_achievement_void");
                break;
            case 2:
                this.star1.setFrame("star_achievement_full");
                this.star2.setFrame("star_achievement_full");
                this.star3.setFrame("star_achievement_void");
                break;
            case 3:
                this.star1.setFrame("star_achievement_full");
                this.star2.setFrame("star_achievement_full");
                this.star3.setFrame("star_achievement_full");
                break;
            default:
        }
        this.achievementsBar.reset(achievementData.current, treshold);
    };
    AchievementsCell.prototype.onClickClaimAchievement = function () {
        BoardManager_1.BoardManager.claimAchievement(this.i - 1, this.rewardIndex);
        this.reset(this.i);
        AudioManager_1.AudioManager.playSound("claim_reward");
    };
    return AchievementsCell;
}(Phaser.GameObjects.Container));
exports.AchievementsCell = AchievementsCell;
